export enum ActiveType {
  PATH = "path",
  QUERY = "query",
}
